export var AccordionSize;
(function (AccordionSize) {
    AccordionSize["Small"] = "small";
    AccordionSize["Large"] = "large";
})(AccordionSize || (AccordionSize = {}));
export var AccordionTheme;
(function (AccordionTheme) {
    AccordionTheme["Box"] = "box";
    AccordionTheme["Line"] = "line";
})(AccordionTheme || (AccordionTheme = {}));
export var AccordionDataHooks;
(function (AccordionDataHooks) {
    AccordionDataHooks["AccordionItemHeader"] = "accordion-item-header";
    AccordionDataHooks["AccordionItemContent"] = "accordion-item-content";
})(AccordionDataHooks || (AccordionDataHooks = {}));
export var AccordionFocusElement;
(function (AccordionFocusElement) {
    AccordionFocusElement[AccordionFocusElement["Header"] = 0] = "Header";
    AccordionFocusElement[AccordionFocusElement["Content"] = 1] = "Content";
})(AccordionFocusElement || (AccordionFocusElement = {}));
export { AccordionDataHooks as DataHooks };
//# sourceMappingURL=types.js.map